import { render } from "./Estoque.vue?vue&type=template&id=158a8de0&ts=true"
import script from "./Estoque.vue?vue&type=script&lang=ts"
export * from "./Estoque.vue?vue&type=script&lang=ts"

import "./Estoque.vue?vue&type=style&index=0&id=158a8de0&lang=css"

import exportComponent from "/Users/camp/Desktop/code-time/acampa-gestao-pra/vuecode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__